import * as Yup from "yup";

export const AddTeamInitialState = {
  name: "",
  shortName: "",
  colorShirt: "",
};

export const AddTeamValidationSchema = Yup.object({
  name: Yup.string().required("Este campo es requerido"),
  shortName: Yup.string()
    .max(8, "Solo se permiten máximo 8 letras")
    .required("Este campo es requerido"),
  colorShirt: Yup.string().required("Este campo es requerido"),
});
